import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    animation: '$skeleton 0.3s linear infinite alternate',
    cursor: 'default'
  },

  '@keyframes skeleton': {
    '0%': {
      backgroundColor: 'hsl(0, 0%, 87%)'
    },

    '100%': {
      backgroundColor: 'hsl(0, 0%, 93%)'
    }
  }
}))

export default useStyles
